import { TZDate } from '@date-fns/tz';
import { addMinutes } from 'date-fns';

import parseDurationAsMinutes from '../duration/parseDurationAsMinutes';
import parseSessionDateTime from '../data/sessionDateTime/parseSessionDateTime';

const wallClockInZone = (instant: Date, timeZone: string): Date => {
  const inZone = TZDate.tz(timeZone, instant);
  return new Date(
    inZone.getFullYear(),
    inZone.getMonth(),
    inZone.getDate(),
    inZone.getHours(),
    inZone.getMinutes(),
  );
};

const isCartItemExpired = (
  item: {
    sessionDateTime: string;
    sessionDuration: string;
    timezone?: string;
  },
  currentTime: Date = new Date(),
): boolean => {
  try {
    const sessionStart = parseSessionDateTime(item.sessionDateTime);
    const durationMinutes = parseDurationAsMinutes(item.sessionDuration);
    const sessionEnd = addMinutes(sessionStart, durationMinutes);
    const now = item.timezone
      ? wallClockInZone(currentTime, item.timezone)
      : currentTime;

    return sessionEnd <= now;
  } catch (error) {
    // If we can't parse, assume it's not expired to be safe
    return false;
  }
};

export default isCartItemExpired;
